import { supabase } from "./supabase-client";

const API_URL = import.meta.env.VITE_API_URL;

export class ApiError extends Error {
  public readonly status: number;
  public readonly code?: string;

  constructor(message: string, status: number, code?: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
  }
}

export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const isFormData = options.body instanceof FormData;
  const callerHeaders = options.headers as Record<string, string> | undefined;
  const headers: Record<string, string> = isFormData
    ? { ...callerHeaders }
    : { "Content-Type": "application/json", ...callerHeaders };
  // Only the runtime may write the multipart boundary; a hand-written value yields an empty body.
  if (isFormData) {
    for (const key of Object.keys(headers)) {
      if (key.toLowerCase() === "content-type") delete headers[key];
    }
  }
  if (session?.access_token) {
    headers.Authorization = `Bearer ${session.access_token}`;
  }

  const res = await fetch(`${API_URL}${path}`, { ...options, headers });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as {
      error?: string;
      code?: string;
    };
    throw new ApiError(body.error || `API error ${res.status}`, res.status, body.code);
  }
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}
